// extracted by mini-css-extract-plugin
export default {"content":"TkauthVideoRedirect_content__ElwYM"};